import { render, staticRenderFns } from "./EventoHospedagem.vue?vue&type=template&id=6b5c7abc&scoped=true"
import script from "./EventoHospedagem.vue?vue&type=script&lang=js"
export * from "./EventoHospedagem.vue?vue&type=script&lang=js"
import style0 from "./EventoHospedagem.vue?vue&type=style&index=0&id=6b5c7abc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b5c7abc",
  null
  
)

export default component.exports